<script>
import {defineComponent} from 'vue';
export default defineComponent ({
    components: {
    },
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        source: {
            type: String,
            required: false,
            default: '',
        },
        height: {
            type: String,
            required: false,
            default: '100%',
        },
        width: {
            type: String,
            required: false,
            default: '95%',
        },
        frameborder: {
            type: String,
            required: false,
            default: '0',
        },
    },
});
</script>

<template>
    <div>
        <h4 v-if="title">{{ title }}</h4>
        <iframe
            srcdoc='<h1 style="text-align:center;">Please wait a moment while the preview is loading in the viewer</h1>'
            onload="this.removeAttribute('srcdoc')"
            :src="source"
            :height="height"
            :width="width"
            :frameborder="frameborder"
            max-height="95%"
        />
        <strong>To generate the file in a separate window, click the link <a style="color:blue;" :href="source" target="_review">HERE</a></strong>
        <div class="clear"></div>
    </div>
</template>
